module.exports = __webpack_public_path__ + "static/media/excellentEmoji.6e1cc4ba.svg";